<div class="outside-box">
  <div class="inside-box">
    <mat-card class="login-card">
      <div class="logo-container">
        <img src="/logo.png" alt="Company Logo" class="login-logo" />
      </div>

      <mat-card-header>
        <mat-card-title>Change Password</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" class="login-form">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Current Password</mat-label>
            <input matInput type="password" formControlName="oldPassword" required autocomplete="off">
          </mat-form-field>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>New Password</mat-label>
            <input matInput type="password" formControlName="newPassword" required autocomplete="off">
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Confirm New Password</mat-label>
            <input matInput type="password" formControlName="newPasswordConfirm" required autocomplete="off">

          </mat-form-field>

          <div class="form-actions">
            <button mat-flat-button color="primary" type="submit" class="submit-button"
              [disabled]="changePasswordForm.invalid || accountService.isLoading">
              Change Password
            </button>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions class="additional-actions">
        <a routerLink="/new-account-setup" class="action-link">Back to Account Setup</a>
      </mat-card-actions>
    </mat-card>
  </div>
</div>